<template>
    <span v-if="controller?.available" class="pb2-surface-toggle" role="group" :aria-label="t('surface_toggle')">
        <button
            v-for="option in options"
            :key="option.key"
            type="button"
            class="pb2-surface-toggle__option"
            :class="{ 'pb2-surface-toggle__option--active': controller.surface.value === option.key }"
            :aria-pressed="controller.surface.value === option.key"
            @click="controller.set(option.key)"
        >
            <Icon :icon="option.icon" class="size-3" />
            {{ option.label }}
        </button>
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBuilderT } from '@src/Common/Builder/host';
import { useSurfaceControllerOptional } from '@src/Common/Builder/Document/surfaceMode';
import type { BuilderSurface } from '@src/Common/Builder/host';

const t = useBuilderT();
const controller = useSurfaceControllerOptional();

const options = computed<{ key: BuilderSurface; label: string; icon: string }[]>(() => [
    { key: 'document', label: t('surface_document'), icon: 'phosphor/regular/article' },
    { key: 'canvas', label: t('surface_canvas'), icon: 'phosphor/regular/layout' },
]);
</script>

<style scoped>
.pb2-surface-toggle {
    display: inline-flex;
    align-items: center;
    padding: 2px;
    background: var(--pb2-surface, #fff);
    border: 1px solid var(--pb2-border, #e4e4e7);
    border-radius: var(--pb2-radius, 6px);
}

.pb2-surface-toggle__option {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 2px 8px;
    font: 600 11px/1.6 -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: var(--pb2-muted, #71717a);
    background: transparent;
    border: 0;
    border-radius: calc(var(--pb2-radius, 6px) - 2px);
    cursor: pointer;
}

.pb2-surface-toggle__option--active {
    color: var(--pb2-text, #18181b);
    background: var(--pb2-surface-raised, #f4f4f5);
    box-shadow: var(--pb2-shadow, 0 1px 3px rgb(0 0 0 / 0.12));
}
</style>
